import React from 'react';

import * as ArchiveActions from 'archive/ArchiveActions';
import {Permissions} from 'auth/PermissionConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as SourceActions from 'file-browser/SourceActions';
import licenses from 'user/Licenses';

import SourceSettingsModal from './SourceSettingsModal';

export interface ProjectSettingsModalProps {
  permissions: Permissions;
  onDelete?: () => void;
  onUpdate?: () => void;
  onRequestClose: () => void;
  sourceId: string;
}

export function ProjectSettingsModal(props: ProjectSettingsModalProps): JSX.Element {
  const isReadOnly = !props.permissions.admin;
  const isArchivable = props.permissions.archivable;
  const canManageCollaborators = props.permissions.canManageCollaborators;
  return (
    <SourceSettingsModal
      // @ts-expect-error
      archiveFn={isArchivable ? ArchiveActions.bulkArchiveSourcesWithDataMods : undefined}
      deleteFn={SourceActions.deleteSource}
      allowAuditorToggling={licenses.hasLicense('LICENSE_REVIEWS')}
      isReadOnly={isReadOnly}
      onDelete={props.onDelete}
      onUpdate={props.onUpdate}
      onRequestClose={props.onRequestClose}
      showCustomSettings={true}
      sourceId={props.sourceId}
      sourceType={ModelTypeConstants.PROJECT}
      canManageCollaborators={canManageCollaborators ?? false}
    />
  );
}
